import { GcfPriceDisplayFormat } from 'src/features/components/editComponentPage/forms/FormSelector.interface';
import {
  ComponentTypes,
  GcfPriceLabelShapeTypeEnum,
  GcfPriceLabelTypeEnum,
  IGcfComponentConfig,
  SUBPRODUCT_PRICE_DISPLAY_FORMAT,
} from 'src/interfaces';

import { COD_COMPONENT_CONFIG } from './gcfCodConfig';
import { COD_THANK_YOU_COMPONENT_CONFIG } from './gcfCodThankYou';
import { GCF_COMBO_STYLE_CONFIG } from './gcfComboStyleConfig';
import { BASE_GCF_COMPONENT_CONFIG } from './gcfComponentCommonConfig';
import { DISCLAIMER_COMPONENT_CONFIG } from './gcfDisclaimerConfig';
import { LISTING_VISUAL_GALLERY_COMPONENT_CONFIG } from './gcfListingVisualGalleryConfig';
import { LOV_COMPONENT_CONFIG } from './gcfListingWithOptionalVisualsConfig';
import { SINGLE_SHELF_COMPONENT_CONFIG } from './gcfSingleShelfConfig';

export const getGcfComponentConfig = (
  componentType?: string,
  override?: Partial<IGcfComponentConfig>,
) => {
  const componentConfigMap = {
    [ComponentTypes.SINGLE_SHELF]: SINGLE_SHELF_COMPONENT_CONFIG,
    [ComponentTypes.PROMOTIONAL_COMPONENT]: BASE_GCF_COMPONENT_CONFIG,
    [ComponentTypes.PROMOTIONAL_SPACE]: BASE_GCF_COMPONENT_CONFIG,
    [ComponentTypes.LISTING_WITH_OPTIONAL_VISUALS]: LOV_COMPONENT_CONFIG,
    [ComponentTypes.COMBO_STYLE]: GCF_COMBO_STYLE_CONFIG,
    [ComponentTypes.LISTING_VISUALS_GALLERY]:
      LISTING_VISUAL_GALLERY_COMPONENT_CONFIG,
    [ComponentTypes.DISCLAIMER]: DISCLAIMER_COMPONENT_CONFIG,
    [ComponentTypes.COD]: COD_COMPONENT_CONFIG,
    [ComponentTypes.COD_THANK_YOU]: COD_THANK_YOU_COMPONENT_CONFIG,
  };

  const baseConfig =
    componentConfigMap[componentType as keyof typeof componentConfigMap];

  return { ...baseConfig, ...override };
};

export const GCF_DEFAULT_VALUES = {
  subProductsDisplayFormatType: GcfPriceDisplayFormat.INLINE,
  priceLabelType: GcfPriceLabelTypeEnum.None,
  priceLabelShapeType: GcfPriceLabelShapeTypeEnum.None,
  subProductPriceDisplayFormatType: SUBPRODUCT_PRICE_DISPLAY_FORMAT.NONE,
};
